import { array, oneOfType, string } from 'prop-types';
import { Route, Switch } from 'react-router-dom';

const propTypes = {
  path: oneOfType([string, array]),
};

export default function PrivateRoute({ path, component: Component, ...props }) {
  return <Route {...props} path={path}>
    {props => <Component {...props} />}
  </Route>
}

PrivateRoute.propTypes = propTypes

export function Router({ children }) {
  return <Switch>
    {children}
  </Switch>
}
